import {
  GET_COMPTE_TIERS,
  PAGE_CHANGED,
  PAGE_LIMIT_CHANGED,
  REMOVE_ERROR,
  RESET_SUCCESS_ACTION,
  RESET_CONFIG,
  SEARCH_COMPTE_TIERS,
  ADD_COMPTE_TIERS,
  UPDATE_COMPTE_TIERS,
  GET_COMPTE_TIERS_LIST_MORE,
} from './constants'

export const fetchCompteTiers = () => ({
  type: GET_COMPTE_TIERS,
})

export const pageChanged = (offset) => ({
  type: PAGE_CHANGED,
  payload: { offset },
})

export const pageLimitChanged = (limit) => ({
  type: PAGE_LIMIT_CHANGED,
  payload: { limit },
})

export const getCompteTiersMore = () => ({
  type: GET_COMPTE_TIERS_LIST_MORE,
})

export const removeError = () => ({
  type: REMOVE_ERROR,
})

export const resetSuccessAction = () => ({
  type: RESET_SUCCESS_ACTION,
})

export const resetCompteTiersConfig = () => ({
  type: RESET_CONFIG,
})

export const onSearch = (search) => ({
  type: SEARCH_COMPTE_TIERS,
  payload: { search },
})

export const createCompteTiers = (compteTiers) => ({
  type: ADD_COMPTE_TIERS,
  payload: { compteTiers },
})

export const updateCompteTiers = (payload, id) => ({
  type: UPDATE_COMPTE_TIERS,
  payload: { newCompteTiers: payload, id },
})
